import { useNavigate } from 'react-router-dom';
import ProductForm from '../components/products/ProductForm';
import productService from '../utils/productService';
import { FaPlus } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const ProductNew = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    await productService.create(data);
    navigate('/dashboard/products');
  };

  return (
    <section className="col-span-1 md:col-span-10 p-4 md:py-6">
      <div className="rounded-lg border border-slate-200 bg-slate-50/70 p-4 shadow-sm md:p-6">
        <div className="mb-6 flex flex-col justify-between gap-4 rounded-lg bg-white p-5 text-left shadow-sm md:flex-row md:items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-emerald-700">
              {t('dashboard.products.label')}
            </p>
            <h2 className="mt-2 text-3xl font-semibold text-[#00595A]">
              {t('dashboard.products.newTitle')}
            </h2>
            <p className="mt-2 text-sm text-slate-500">
              {t('dashboard.products.newSubtitle')}
            </p>
          </div>
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded bg-[#00595A] text-white shadow-sm">
            <FaPlus className="h-6 w-6" />
          </div>
        </div>

        <div className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm md:p-6">
          <ProductForm
            onSubmit={handleSubmit}
            submitLabel={t('dashboard.products.createProduct')}
            showRequiredWaitingFields={false}
          />
        </div>
      </div>
    </section>
  );
};

export default ProductNew;
